import * as d3 from "d3";

// Do not move other nodes on drag
const fixateNodes = (node: any, thisNode: any) => {
  node.each((d: any) => {
    if (thisNode != d) {
      d.fx = d.x;
      d.fy = d.y;
    }
  });
};

/**
 * Implements dragging behaviour to nodes in the workspace chart
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const drag = (simulation: d3.Simulation<any, undefined>, node: any) => {
  // Drag start
  function dragStarted(event: any) {
    if (!event.active) simulation.alphaTarget(0.3).restart();
    event.subject.fx = event.subject.x;
    event.subject.fy = event.subject.y;
  }

  // During drag
  function dragged(event: any, d: any) {
    event.subject.fx = event.x;
    event.subject.fy = event.y;
    fixateNodes(node, d);
  }

  return d3.drag().on("start", dragStarted).on("drag", dragged);
};

export default drag;
